module.exports = __webpack_public_path__ + "img/daishouli.f88d8baa.png";